import { useEffect, useState } from "react";

/** Client-side paging shared by the EFT / Check / Debit payment reports. */
export default function usePaymentPagination(data, rowsKey = "providerreports") {
    const [itemsPerPage, setitems] = useState("50");
    const [offset, setoffset] = useState("0");
    const [limit, setlimit] = useState("50");
    const [page, setpage] = useState(1);

    function pageBack() {
        if (page > 1) {
            setpage(page - 1);
        }
        setoffset((page - 1) * itemsPerPage);
        setlimit(page * itemsPerPage);
    }

    function pageForward() {
        if (data) {
            if (data[rowsKey]) {
                if (data[rowsKey].length > limit) {
                    setpage(page + 1);
                }
            }
        }
        setoffset((page - 1) * itemsPerPage);
        setlimit(page * itemsPerPage);
    }

    useEffect(() => {
        setlimit(page * itemsPerPage);
    }, [itemsPerPage]);

    return { itemsPerPage, setitems, offset, limit, page, pageBack, pageForward };
}


